import { jsx as _jsx } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import { StyledFooterBottomBarLink } from "./footer-bottom-bar-link-component.scss";
const FooterBottomBarLink = (props)=>{
    const { title, url, translate, onClick, customAttribute } = props;
    const onLinkClick = (event)=>onClick === null || onClick === void 0 ? void 0 : onClick(event);
    return /*#__PURE__*/ _jsx(StyledFooterBottomBarLink, {
        className: "footer-bottom-bar-link-component",
        href: url,
        onClick: onLinkClick,
        "data-footer-link-type": customAttribute,
        children: translate(title)
    });
};
export default withGenericConfig(FooterBottomBarLink);
